import { Component } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BaseServiceLibraryComponent } from '../../base-service-library.component';
import { ServiceTypes } from '../../../../_shared/enums/service-type.enum';
import { CommonModule } from '@angular/common';
import { ScheduleType } from '../../../../_shared/enums/service-schedule-type.enum';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-service-library-filter-page',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, TranslocoPipe],
  templateUrl: './service-library-filter-page.component.html',
  styleUrl: './service-library-filter-page.component.scss'
})
export class ServiceLibraryFilterPageComponent extends BaseServiceLibraryComponent {
  readonly ScheduleType = ScheduleType;

  protected override onSelectServiceType(serviceType: ServiceTypes): void {
    if (this.serviceTypeDisabled) return;

    this.selectedServiceType = serviceType;
    if (this.canProceed) this.proceed();
  }
  
  protected override onBackButtonClick(): void {
    this.router.navigate(['/asset-management/service-library']);
  }

  protected override getFilters(): any {
    return {
      selectedMake: this.selectedMake,
      selectedModel: this.selectedModel,
      selectedYear: this.selectedYear,
      selectedServiceType: this.selectedServiceType
    }; 
  }

  protected override applyPageFilterState(pageFilter: any): void {}
  protected override onRefresh(): void {} 
  protected override shouldRefresh(): boolean { return false; }
}